import { OptionType } from "../../sanity";

export const GARFIELD_HOME_MESSAGES = [
  "I KNOW THINGS I SHOULDN'T",
  "HE'S GOT IMPOSTER SYNDROME",
  "CAN YOU TURN YOUR WEBCAM ON?",
  "EMAIL HIM, HE'll LOVE IT",
  "EMAIL HIM AT JUSTINMA3@GMAIL.COM",
  "HIS INSTA IS @NIT.SU.J",
  "WILL YOU FOLLOW HIM?",
];

const GARFIELD_WEBSITE_MESSAGES = [
  "I KNOW HIS GITHUB PASSWORD",
  "HE HARDCODED ME",
  "ALL HIS CODE IS ON GITHUB",
  "STEAL HIS CODE. IT'S EASY",
  "TOOK HIM WAY TOO LONG TO BUILD THIS",
];

const GARFIELD_FILM_MESSAGES = [
  'LOOK UP "MA BROS TRICK SHOTS"',
  "HIS COLLEGE CHANNEL IS ALMOND FACTORY",
  "HIS YOUTUBE HAS UNLISTED CONTENT",
  "HIS LETTERBOXD IS W3IRDFISH3S",
  "HE NEEDS MORE VIEWS ON YOUTUBE",
];

const GARFIELD_DJ_MESSAGES = [
  "HIS FIRST SET EVER IS ON SOUNDCLOUD",
  "I'VE SEEN HIM USE BEAT SYNC",
  "HIS SOUNDCLOUD HAS EXTRA CONTENT",
  "HE NEEDS MORE LIKES ON SOUNDCLOUD",
];

const GARFIELD_MISC_MESSAGES = [
  "THIS SECTION USED TO BE BLOGS",
  "HE TRIED INKTOBER AGAIN BUT GAVE UP",
  "THE APPLE MURDERER IS NEAR...",
  "APPLE MURDERER IS A CHILL GUY",
];

export const OPTION_TYPE_TO_GARFIELD_MESSAGES: Record<OptionType, string[]> = {
  website: GARFIELD_WEBSITE_MESSAGES,
  film: GARFIELD_FILM_MESSAGES,
  dj: GARFIELD_DJ_MESSAGES,
  blog: GARFIELD_MISC_MESSAGES,
  about: [],
};
